var r="4.22.3";export{r as version};
//# sourceMappingURL=package.json.js.map
